import { waitPromise } from '../../shared/util/waitPromise';
import moment from 'moment';
import { NUM_TRIES, SECONDS_TIMEOUT } from './confirmCorrelationIdRecursive';

/** */
async function confirmValueRecursive<T, P>(
  value: T,
  getPromise: () => Promise<P>,
  extractValue: (promiseReturn: P) => T,
  startTime = moment(),
  availableTries = NUM_TRIES
): Promise<T> {
  if (availableTries <= 0) {
    throw new Error('error.available_attempts_exceeded');
  }
  if (moment().diff(startTime, 'seconds') > SECONDS_TIMEOUT) {
    throw new Error('error.timeout_exceeded');
  }
  const promiseReturn = await getPromise();
  const extractedValue = extractValue(promiseReturn);
  if (extractedValue !== value) {
    // add some delay with exponential backOff with 2^i to avoid too many requests
    const exponentialBackOffSeconds = 2 ** (NUM_TRIES - availableTries);
    await waitPromise(1000 * exponentialBackOffSeconds);
    return confirmValueRecursive(
      value,
      getPromise,
      extractValue,
      startTime,
      availableTries - 1
    );
  }
  return extractedValue;
}

export default confirmValueRecursive;
